// src/features/auth/authSlice.js

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: sessionStorage.getItem("vendorAuthToken"),
  refreshToken: sessionStorage.getItem("vendorRefreshToken"),
  vendorData: JSON.parse(sessionStorage.getItem("vendorData") || "{}"),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(state, action) {
      const data = action.payload;
      sessionStorage.setItem("vendorAuthToken", data.token);
      sessionStorage.setItem("vendorRefreshToken", data.refreshToken);
      sessionStorage.setItem("vendorData", JSON.stringify(data.data));

      state.token = data.token;
      state.refreshToken = data.refreshToken;
      state.vendorData = data.data;
    },
    logout(state) {
      sessionStorage.removeItem("vendorAuthToken");
      sessionStorage.removeItem("vendorRefreshToken");
      sessionStorage.removeItem("vendorData");

      state.token = "";
      state.refreshToken = "";
      state.vendorData = {};
    },
    setToken(state, action) {
      state.token = action.payload;
      sessionStorage.setItem("vendorAuthToken", action.payload);
    },
    clearToken(state) {
      state.token = null;
      sessionStorage.removeItem("vendorAuthToken");
    },
    setRefreshToken(state, action) {
      state.refreshToken = action.payload;
      sessionStorage.setItem("vendorRefreshToken", action.payload);
    },
    clearRefreshToken(state) {
      state.refreshToken = null;
      sessionStorage.removeItem("vendorRefreshToken");
    },
    setVendorData(state, action) {
      state.vendorData = action.payload;
      sessionStorage.setItem("vendorData", JSON.stringify(action.payload));
    },
    clearVendorData(state) {
      state.vendorData = null;
      sessionStorage.removeItem("vendorData");
    },
  },
});

export const {
  setToken,
  clearToken,
  setRefreshToken,
  clearRefreshToken,
  setVendorData,
  clearVendorData,
  login,
  logout,
} = authSlice.actions;

export default authSlice.reducer;
